// CANONICAL COPY (GH #7115). src/constants/obligations/obl-secure-area-working.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-secure-area-working',
  title: 'Verify procedures for working in secure areas',
  description:
    'Confirm that security measures and guidelines for working in secure areas — data centres, server rooms, laboratories and other restricted zones — are designed, documented and communicated to authorised personnel. Procedures shall cover supervision of visitors, use of recording equipment, unattended work and the handling of portable storage and photographic devices. Review the secure-area working standard and access / activity records.',
  category: 'assets',
  scfIds: ['SCF-PHY-006'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'Secure-area working procedure is published' },
    { type: 'document-within-sla', description: 'Procedure review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
